import { render, staticRenderFns } from "./search_results.vue?vue&type=template&id=405b734c&scoped=true&"
import script from "./search_results.vue?vue&type=script&lang=js&"
export * from "./search_results.vue?vue&type=script&lang=js&"
import style0 from "./search_results.vue?vue&type=style&index=0&id=405b734c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405b734c",
  null
  
)

export default component.exports